import { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { Button } from '@/components/ui/button';

const LiliWelcomePopup = ({ onClose }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if welcome popup has been shown before
    const hasSeenWelcome = localStorage.getItem('lili_welcome_shown');
    
    if (!hasSeenWelcome) {
      // Show popup after 5 seconds (changed from 2)
      const timer = setTimeout(() => {
        setIsVisible(true);
      }, 5000);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    localStorage.setItem('lili_welcome_shown', 'true');
    if (onClose) onClose();
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[100] p-4 animate-in fade-in duration-300">
      <div className="bg-white rounded-2xl shadow-2xl max-w-md w-full p-8 relative animate-in zoom-in duration-300">
        <button
          onClick={handleClose}
          className="absolute top-4 right-4 text-gray-700 hover:text-gray-900 transition bg-gray-200 hover:bg-gray-300 rounded-full p-2"
          aria-label="Close"
        >
          <X className="w-5 h-5" />
        </button>

        <div className="text-center">
          {/* Lili Logo - Rotating animation */}
          <div className="inline-flex items-center justify-center w-24 h-24 mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_luxury-collective/artifacts/g86n9tir_Lili%20Logo.1-cutout.png" 
              alt="Lili Logo" 
              className="w-24 h-24 object-contain animate-spin-slow"
              style={{ animationDuration: '3s', animationIterationCount: 'infinite', animationTimingFunction: 'linear' }}
            />
          </div>

          {/* Welcome Message - No emojis */}
          <h2 className="text-2xl font-bold mb-4 text-black">
            Welcome to The Haute Circle!
          </h2>
          
          <p className="text-black mb-6 leading-relaxed font-medium">
            I'm <span className="font-bold" style={{ color: '#D4AF37' }}>Lili</span>, your personal AI concierge. 
            I'm here to help you explore our luxury fractional ownership offerings, answer your questions, 
            and guide you through your journey with us.
          </p>

          <div className="bg-[#F5F5DC] p-4 rounded-lg mb-6">
            <p className="text-sm text-black font-medium">
              Need assistance? Click the <strong>Concierge button</strong> in the bottom-right corner anytime!
            </p>
          </div>

          <Button
            onClick={handleClose}
            style={{ background: 'linear-gradient(to right, #D4AF37, #C5A028)' }}
            className="w-full hover:opacity-90 text-white font-bold py-4 text-base shadow-lg hover:shadow-xl transition-all"
          >
            Let's Get Started
          </Button>
        </div>
      </div>
    </div>
  );
};

export default LiliWelcomePopup;
